export default __webpack_public_path__ + "static/media/LMNT-sponsor.7f527590.svg";